import gql from 'graphql-tag'

export default gql`
  query Message($id: ID!){
    message (id: $id) {
      id,
      createdAt,
      ownerId,
      ownerType,
      opponentType,
      opponentId,
      conversationId,
      readedAt,
      content,
      eventDates {
        eventDate,
        selected
      },
      eventSelected
    }
  }
`



// WEBPACK FOOTER //
// ./src/graphql/chat/queries/message.query.js